import { useEffect, useState } from 'react'
import { View } from 'reshaped/bundle'

export const PreviewStep = () => {
	const [isReady, setIsReady] = useState(false)

	useEffect(() => {
		// Prevent loading script multiple times
		if (customElements.get('moneylion-lending-explore')) {
			setIsReady(true)
			return
		}

		const script = document.createElement('script')
		script.src = 'https://www.moneylion.com/network/fiona/loans-embed/web-component/lending-explore/index.js'
		script.type = 'application/javascript'
		script.async = true

		script.onload = () => {
			if (customElements.get('moneylion-lending-explore')) {
				setIsReady(true)
			} else {
				console.warn('Script loaded but web component not defined yet')
			}
		}

		script.onerror = () => {
			console.error('Failed to load the web component script')
		}

		document.body.appendChild(script)

		return () => {
			document.body.removeChild(script)
		}
	}, [])
	return (
		<View>
			{/* @ts-ignore - web-components must not be self-closing */}
			{isReady && <moneylion-lending-explore />}
		</View>
	)
}
